import React from "react";
import { Icon } from "semantic-ui-react";
import { instantFromApi } from "../utils/dateTime";
import { Instant } from "js-joda/dist/js-joda";

function getNextRunMinutes(bi) {
  // Was sometimes throwing "Unable to obtain Instant from TemporalAccessor" when used instantFromApi(Instant.now()).until(bi.nextRunAt, ChronoUnit.MINUTES)
  return bi.nextRunAt ? Math.ceil((instantFromApi(bi.nextRunAt).epochSecond() - Instant.now().epochSecond()) / 60) : 0;
}

export default ({ botInstance }) => {
  const nextRunMinutes = getNextRunMinutes(botInstance);
  return (
    nextRunMinutes > 2 && <Icon name="pause circle outline" color="purple" title={`Next run in ${nextRunMinutes}min.`} />
  );
};



// WEBPACK FOOTER //
// ./src/bot/PausedIcon.js